// Funnel measurement via Firebase Analytics (GA4 property G-18Z5GM8CVQ, already
// enabled on the project). Everything here is fire-and-forget: analytics must
// never block or break the game loop, and it silently no-ops where GA isn't
// supported (some in-app browsers, adblock).
//
// The funnel we actually care about for validating stream #1:
//   login → join_game → game_finished → share_result / follow_presenter
import { getApp } from 'firebase/app';
import { Analytics, getAnalytics, isSupported, logEvent } from 'firebase/analytics';

let analytics: Analytics | null = null;
let ready: Promise<void> | null = null;

const init = (): Promise<void> => {
  if (!ready) {
    ready = isSupported()
      .then((ok) => {
        if (ok) analytics = getAnalytics(getApp());
      })
      .catch(() => { /* unsupported environment — track() stays a no-op */ });
  }
  return ready;
};

export const track = (
  event: string,
  params?: Record<string, string | number | boolean>
): void => {
  init()
    .then(() => {
      if (analytics) logEvent(analytics, event, params);
    })
    .catch(() => { /* never surface analytics failures */ });
};
